import ScrollReveal from "scrollreveal";
import moment from "moment";
import easyAutocomplete from './vendors/jquery.easy-autocomplete.min.js';
import sentDataBackendDoubleOptin from './sentDataBackendDoubleOptin.js';
import { setCookie, readCookie, allowCookies } from './utils.js'
import otListener from './otListener'
import { initSelectIndustrias } from "./commons/select-industrias.js";
import intlTelInput from './commons/intl-tel-input/intl-tel-input.js';
import {initQuotes} from './../quotes-component/initQuotes.js';

require('moment-timezone');

jQuery(document).ready(function ($) {
    var $menuToggle = $("#toggle-menu"),
        $header = $('body > header'),
        $main = $("main"),
        $logo = $("header .wrapper a img.logo-academy"),
        $buttonFooterSuscription = $("#button-subscribe"),
        $hideFormSubscribe = $("#section-form"),
        $buttonHideForm = $("#hide-form-subscribe"),
        $formSubscribe = $("#form-subscribe"),
        $formSubscribeButton = $("#form-subscribe button"),
        $formFreqQuest = $(".form-frequent-questions"),
        $formFreqQuestButton = $(".form-frequent-questions button"),
        $formWebinar = $("#form-webinar"),
        $formWebinarButton = $("#form-webinar button"),
        $tabsCourses = $(".c-tabs"),
        $videoCourse = $("#video-course")[0],
        $buttonMute = $("#mute"),
        $videoCourseMobile = $("#video-course-mobile")[0],
        $buttonMuteMobile = $("#mute-mobile"),
        $getUrl = window.location,
        $baseUrl = $getUrl.protocol + "//" + $getUrl.host,
        $imgPath = "/wp-content/themes/doppler-webpack/img/",
        $accordionTab = $(".accordion-item"),
        $titleToggle = $(".card-type").closest('figure'),
        $toggleUserMenu = $("#user-menu"),
        $capsuleVideo = $(".capsule-internal .video-iframe div"),
        $webinarVideo = $(".webinar-internal .video-iframe div"),
        $idWebinar = $formWebinar.find('input[name="id_webinar"]').val(),
        $scrollContainerMinCards = $('.scroll-container'),
        $accordionLessonHeader = $(".curriculum-lesson-header"),
        $tabCourse = $("#tab-course"),
        $tabLesson = $("#tab-lesson"),
        $tabPodcast = $("#tab-podcast"),
        $tabMorePodcasts = $("#tab-more-podcasts"),
        $modalFormCertificate = $(".modal-certificate"),
        $getCertificateButton = $("#obtain-certificate"),
        $getCertificateLink = $("#obtain-certificate-link"),
        $closeBtnFormCertificate = $(".modal-certificate .close-button"),
        $formCertificateButton = $("#form-certificate button"),
        $cancelQuizLink = $(".parcial .header-parcial a"),
        $videoHero = $("#video-bg"),
        $formSuggestionCourseButton = $(".form-suggestion button"),
        $formSuggestionHomeButton = $(".form-suggestion-home button"),
        $formSuggestionWebinarButton = $(".form-suggestion-webinar button.btnWebinar"),
        $formSuggestionCapsulaButton = $(".form-suggestion-capsula button.btnCapsula");
    const logOutButton = document.getElementById('logOutButton');
    const adminUrl = document.getElementById('adminUrl').innerHTML;
    const logOutUrl = document.getElementById('logOutUrl').innerHTML;

    var player;

    const sliderContainer = document.getElementById('quotesContainer');
    if (sliderContainer) {
      initQuotes($,sliderContainer);
    }

    const industry = document.getElementById('industry');
    if (industry != null && industry != undefined) {
        initSelectIndustrias(industry, document.documentElement.lang);
    }
    const phone = document.getElementById('phone');
    if (phone != null && phone != undefined) {

        intlTelInput(phone, {
            utilsScript: "/wp-content/themes/doppler-webpack/js/src/commons/intl-tel-input/utils.js",
            separateDialCode: true,
            initialCountry: "auto",
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback("AR"));
            }
        });
    }

    if (logOutButton != null && logOutButton != undefined) {
        logOutButton.addEventListener('click', () => {
            const data = new FormData();
            data.append('action', 'ajax_logout');
            localStorage.removeItem('email_loggedIn');
            fetch(adminUrl, {
                method: 'POST',
                credentials: 'same-origin',
                body: data,
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    window.location.href = logOutUrl;
                });
        });


    }
    set_time_by_webinar();

    if ($capsuleVideo.length > 0) {
        loadPlayer();
    }

    if ($webinarVideo.length > 0) {
        loadPlayer();
    }

    function loadPlayer() {
        if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubePlayerAPIReady = function () {
                if ($capsuleVideo.length > 0) {
                    onYouTubePlayerCapsule();
                } else if ($webinarVideo.length > 0) {
                    onYouTubePlayerWebinar();
                    setTimeout(() => $(".webinar-internal .video-iframe #player").removeClass("hidden"), 1250);
                }
            };
        }
    }

    function getParamValue(name, domain) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(domain);
        if (!!results) {
            return results[1];
        } else {
            return 0;
        }
    }

    function onYouTubePlayerCapsule() {
        player = new YT.Player('player', {
            height: '490',
            width: '880',
            videoId: getParamValue('v', $(".capsule-internal .video-iframe div#player").attr('data-attr')),
            playerVars: { controls: 1, showinfo: 0, rel: 0, showsearch: 0, iv_load_policy: 3 },
            events: {
                'onStateChange': onPlayerStateChange,
                'onError': catchError
            }
        });
    }

    function onYouTubePlayerWebinar() {
        player = new YT.Player('player', {
            height: '490',
            width: '880',
            videoId: getParamValue('v', $(".webinar-internal .video-iframe div#player").attr('data-attr')),
            playerVars: { controls: 1, showinfo: 0, rel: 0, showsearch: 0, iv_load_policy: 3 },
            events: {
                'onStateChange': onPlayerStateChange,
                'onError': catchError
            }
        });
    }

    var done = false;

    function incrementUserViews() {
        if (local_object.is_prod == '1') {
            $.post('https://app2.fromdoppler.com/WebSite/IncrementCapsules').done(function () {
                console.log('increment success');
            });
        }
    }

    function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING && !done) {
            $.post(local_object.ajax_url, {
                action: "register_visualization",
                item: "capsula",
                item_id: $("#capsula-id").val()
            }).done(incrementUserViews);
            done = true;
        } else if (event.data == YT.PlayerState.ENDED) {
            //location.reload();

            $(".webinar-internal .video-iframe, .capsule-internal .video-iframe").fadeOut(250, function () {
                $(this).addClass('suggestion-active');
                $(".webinar-internal .suggestion-webinar, .capsule-internal .suggestion-webinar").addClass("overlay-subscribe");
            }).fadeIn(750);
        }
    } // Control player state

    $('.link-suggestion-reload').on('click', function () { location.reload(); });

    function catchError(event) {
        if (event.data == 100) console.log("error youtube");
    }// Catch error Youtube

    $menuToggle.on("click", function () {
        $header.toggleClass("open");

        if ($header.hasClass("open")) {
            $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo.png");
        } else if ($main.hasClass("home") && !$header.hasClass("scrolled")) {
            $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo-white.png");
        }
        return false;
    });// Open lateral menu



    $(function () {
        var distance = $(window).scrollTop();
        if (distance >= 50) {
            $header.addClass("scrolled");
        }
    }); // When reload page start in the top

    $(window).scroll(function () {
        if ($(this).scrollTop() > 50 && !$header.hasClass("scrolled")) {
            $header.addClass("scrolled");
        } else if ($(this).scrollTop() < 50 && $main.hasClass("home")) {
            $header.removeClass("scrolled");
        }
    });// Add class scrolled when scroll page

    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 50 && $main.hasClass("home")) {
                $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo.png");
            } else {
                if ($main.hasClass("home") && !$header.hasClass('open')) {
                    $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo-white.png");
                } else {
                    $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo.png");
                }
            }
        });
    });// Change state the logo when scroll page

    $(function () {
        if ($main.hasClass("home")) {
            if ($header.hasClass("scrolled")) {
                $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo.png");
            } else {
                $logo.attr("src", $baseUrl + $imgPath + "doppler-academy-logo-white.png");
            }
        }
    });// Change state the logo in mobile

    $buttonFooterSuscription.on("click", function () {
        if (!!(localStorage.getItem('email_loggedIn'))) {
            $hideFormSubscribe.find("input[type=email]").val(localStorage.getItem('email_loggedIn'));
        } else if (!!(getURLParam('email'))) {
            $hideFormSubscribe.find("input[type=email]").val(decodeURIComponent(getURLParam('email')));
        }

        $hideFormSubscribe
            .addClass("open")
            .find("input[type=email]")
            .focus();
    });// Open form suscription the footer


    // Check cant of downloads for completed course.

    if ($('main').hasClass('courses-internal') && ($('#obtain-certificate').attr('disabled') == undefined)) { // Botón habilitado
        if (!!readCookie('certificates')) {
            var $arrayLastCertificates = JSON.parse(readCookie('certificates')),
                $courseId = $('.video-title').attr('data-id'),
                $userSession = readCookie("email_loggedIn");

            var getIndex = $arrayLastCertificates.findIndex(function (certificate) {
                return certificate.userSession == $userSession;
            });

            if (getIndex != -1) {
                var $coursesByUser = $arrayLastCertificates[getIndex].completedCourses;
                var getIndexCourse = $coursesByUser.findIndex(function (course) {
                    return course.courseId == $courseId;
                });

                if (getIndexCourse != -1) {
                    var $cantDownloads = $arrayLastCertificates[getIndex].completedCourses[getIndexCourse].countCertificates;

                    if ($cantDownloads >= 100) {
                        $getCertificateButton.parent().attr('data-title', 'Haz llegado a tu límite de descargas.')
                        $getCertificateButton.attr('disabled', 'disabled');
                        $getCertificateButton.parent().removeClass('hide-tooltip');

                        $getCertificateLink.parent().attr('data-title', 'Haz llegado a tu límite de descargas.')
                        $getCertificateLink.attr('disabled', 'disabled');
                        $getCertificateLink.parent().removeClass('hide-tooltip');
                    } else {
                        $getCertificateButton.parent().addClass('hide-tooltip');
                        $getCertificateLink.parent().addClass('hide-tooltip');
                    }
                } else {
                    $getCertificateButton.parent().addClass('hide-tooltip');
                    $getCertificateLink.parent().addClass('hide-tooltip');
                }
            } else {
                $getCertificateButton.parent().addClass('hide-tooltip');
                $getCertificateLink.parent().addClass('hide-tooltip');
            }
        } else {
            $getCertificateButton.parent().addClass('hide-tooltip');
            $getCertificateLink.parent().addClass('hide-tooltip');
        }
    }


    $formCertificateButton.on("click", function () {
        event.preventDefault();
        var $formCertificate = $('#form-certificate'),
            $name, $courseName, $date, $arrayCertificates = [];
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        $date = dd + '/' + mm + '/' + yyyy;


        if (validateForm($formCertificate)) {
            $name = $formCertificate.find('input[name=name]').val();
            $courseName = $('.video-title').attr('data-title');
            $courseId = $('.video-title').attr('data-id');
            $userSession = readCookie("email_loggedIn");


            forceDownload($name, $courseName, $date);

            if (!readCookie('certificates')) {
                var $completedCourse = { userSession: $userSession, completedCourses: [{ courseId: $courseId, countCertificates: 1 }] };
                $arrayCertificates.push($completedCourse);
                allowCookies('certificates', JSON.stringify($arrayCertificates), 1000, 'C0003');
            }
            else {
                var $arrayLastCertificates = JSON.parse(readCookie('certificates'));

                var getIndex = $arrayLastCertificates.findIndex(function (certificate) {
                    return certificate.userSession == $userSession;
                });

                if (getIndex != -1) {
                    var $coursesByUser = $arrayLastCertificates[getIndex].completedCourses;

                    var getIndexCourse = $coursesByUser.findIndex(function (course) {
                        return course.courseId == $courseId;
                    });

                    if (getIndexCourse != -1) {
                        $cantDownloads = $arrayLastCertificates[getIndex].completedCourses[getIndexCourse].countCertificates;

                        if (($cantDownloads + 1) == 100) {
                            $getCertificateButton.parent().attr('data-title', 'Haz llegado a tu límite de descargas.')
                            $getCertificateButton.attr('disabled', 'disabled');
                            $getCertificateButton.parent().removeClass('hide-tooltip');

                            $getCertificateLink.parent().attr('data-title', 'Haz llegado a tu límite de descargas.')
                            $getCertificateLink.attr('disabled', 'disabled');
                            $getCertificateLink.parent().removeClass('hide-tooltip');
                        }

                        $arrayLastCertificates[getIndex].completedCourses[getIndexCourse].countCertificates = $cantDownloads + 1;
                        allowCookies('certificates', JSON.stringify($arrayLastCertificates), 1000, 'C0003');
                    } else {
                        var $addCourse = { courseId: $courseId, countCertificates: 1 };
                        $arrayLastCertificates[getIndex].completedCourses.push($addCourse);
                        allowCookies('certificates', JSON.stringify($arrayLastCertificates), 1000, 'C0003');
                    }
                } else {
                    var $completedCourse = { userSession: $userSession, completedCourses: [{ courseId: $courseId, countCertificates: 1 }] };
                    $arrayLastCertificates.push($completedCourse);
                    allowCookies('certificates', JSON.stringify($arrayLastCertificates), 1000, 'C0003');
                }
            }

            $modalFormCertificate.removeClass('open');
            $('.modal-overlay').removeClass('show');
            $formCertificate[0].reset();
        }
    });

    $buttonHideForm.on("click", function () {
        $hideFormSubscribe.removeClass("open");
    });// Hide form suscription the footer

    $formSubscribeButton.on("click", function (event) {
        event.preventDefault();
        var $buttonForm = $(this);
        if (validateForm($formSubscribe)) {
            $formSubscribe.addClass("disabled");
            $formSubscribeButton.attr('disabled', 'disabled');
            $formSubscribeButton.addClass("button--loading");

            var $email = $formSubscribe.find('input[type=email]'),
                $aceptoPoliticas = $('#acepto_politicas_footer').is(':checked'),
                $aceptoPromociones = $('#acepto_promociones_footer').is(':checked');

            var data = {
                email: $email.val(),
                acepto_politicas: $aceptoPoliticas,
                acepto_promociones: $aceptoPromociones
            };

            sentDataBackendDoubleOptin(data, "footer", $formSubscribe, $buttonForm);
            allowCookies('email_subscriber', $email.val(), 100000, 'C0003');
            allowCookies('acepto_promociones', $aceptoPromociones, 100000, 'C0003');
            setCookie('acepto_politicas', $aceptoPoliticas, 100000);

        }
    });// Function to get data the form

    $formFreqQuestButton.on("click", function (event) {
        event.preventDefault();
        var $buttonForm = $(this);
        if (validateForm($formFreqQuest)) {
            $formFreqQuest.addClass("disabled");
            $(this).attr('disabled', 'disabled');
            $(this).addClass("button--loading");

            var $email = $formFreqQuest.find('input[type=email]'),
                $message = $formFreqQuest.find('.comments'),
                $aceptoPoliticas = $formFreqQuest.find('input[name=acepto_politicas]').is(':checked'),
                $aceptoPromociones = $formFreqQuest.find('input[name=acepto_promociones]').is(':checked');

            var data = {
                email: $email.val(),
                message: $message.val(),
                acepto_politicas: $aceptoPoliticas,
                acepto_promociones: $aceptoPromociones
            };

            sentDataBackend(data, "subscriber-questions", "frequent-questions", $formFreqQuest, $buttonForm);

            allowCookies('email_subscriber', $email.val(), 100000, 'C0003');
            allowCookies('acepto_promociones', $aceptoPromociones, 100000, 'C0003');
            setCookie('acepto_politicas', $aceptoPoliticas, 100000);

        }
    });// Function to get data the form

    function formSuggestionSendData(form, origin) {
        var $buttonForm = form.find('button');
        var $formEmail = form.find('input[type=email]').val();

        var $currentEmail = '';
        if (typeof $formEmail === "undefined") {
            if (form.hasClass('form-suggestion-webinar')) {
                $currentEmail = readCookie('email_subscriber');
            } else {
                $currentEmail = localStorage.getItem('email_loggedIn');
            }
        } else {
            $currentEmail = $formEmail;
        }

        if (validateForm(form)) {
            form.addClass("disabled");
            $(this).attr('disabled', 'disabled');
            $buttonForm.addClass("button--loading");

            var $email = $currentEmail,
                $message = form.find('.comments'),
                $entityId = typeof $('.video-title').attr('data-id') === "undefined" ? 0 : $('.video-title').attr('data-id'),
                $aceptoPoliticas = form.find('input[name=acepto_politicas]').is(':checked'),
                $aceptoPromociones = form.find('input[name=acepto_promociones]').is(':checked');

            var data = {
                origin: origin,
                email: $email,
                entityId: $entityId,
                message: $message.val(),
                acepto_politicas: $aceptoPoliticas,
                acepto_promociones: $aceptoPromociones
            };

            sentDataBackend(data, origin, "sugerencias", form, $buttonForm);
        }
    }

    $formSuggestionHomeButton.on('click', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        formSuggestionSendData($form, 'Academy-Sugerencias-Home');
    });

    $formSuggestionCourseButton.on('click', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        formSuggestionSendData($form, 'Academy-Sugerencias-Curso');
    });

    $formSuggestionWebinarButton.on('click', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        formSuggestionSendData($form, 'Academy-Sugerencias-Webinar');
    });

    $formSuggestionCapsulaButton.on('click', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        formSuggestionSendData($form, 'Academy-Sugerencias-Capsula');
    });

    function cookieWebinar() {
        var hideForm = false,
            subscriptionWebinarArray = [];

        if (!!readCookie("webinar_subscription_v2")) {
            subscriptionWebinarArray = JSON.parse(readCookie('webinar_subscription_v2'));

            subscriptionWebinarArray.findIndex(function (subscriptionWebinar) {
                if (subscriptionWebinar.idWebinar == $idWebinar) {
                    hideForm = true;
                    $(".webinar-internal .subscribe-next-webinar .join-webinar a").attr('href', subscriptionWebinar.joinUrl);
                }
            });

            if (!hideForm && ($('.main-content--webinar').attr('data-type') == 2)) { // Si el ID no esta en la cookie y es webinar pasado
                hideForm = true;
                var $webinar_subscription_item = { idWebinar: $idWebinar, joinUrl: '' };
                subscriptionWebinarArray.push($webinar_subscription_item);

                allowCookies('webinar_subscription_v2', JSON.stringify(subscriptionWebinarArray), 100000, 'C0003');

            }
        } else if (!!readCookie("email_loggedIn") && ($('.main-content--webinar').attr('data-type') == 2)) {
            hideForm = true;
            var $webinar_subscription_item = { idWebinar: $idWebinar, joinUrl: '' };
            subscriptionWebinarArray.push($webinar_subscription_item);

            allowCookies('webinar_subscription_v2', JSON.stringify(subscriptionWebinarArray), 100000, 'C0003');
        }


        if (hideForm || readCookie("webinar_podcast_v2")) {
            if ($(".overlay-subscribe").hasClass("subscribe-next-webinar")) {
                $(".webinar-internal .overlay-subscribe.webinar").hide();
                $(".webinar-internal .subscribe-next-webinar").fadeIn(500);
                $(".webinar-internal .subscribe-next-webinar").css('display', 'flex');
            } else {
                $(".webinar-internal .overlay-subscribe.webinar").fadeOut(1000, function () {
                    $(".webinar-internal .video-iframe").removeClass("overlay");
                });
            }
        } else {
            if (!!(localStorage.getItem('email_loggedIn'))) {
                $formWebinar.find("input[type=email]").val(localStorage.getItem('email_loggedIn'));
            } else if (!!(getURLParam('email'))) {
                $formWebinar.find("input[type=email]").val(decodeURIComponent(getURLParam('email')));
            }
        }
    }// Function to validate register the user in webinar usign the Cookie
    cookieWebinar();//Call function previus


    function cookiePodcast() {
        if (readCookie("webinar_podcast_v2") || readCookie("webinar_webinar_v2")) {
            $(".podcasts .overlay-subscribe.podcast").fadeOut(1000, function () {
                $(".video-iframe.suggestion-overlay.overlay").removeClass("overlay");
            });
        }
    }
    cookiePodcast();
    // Function to validate form and send data backend
    /*
    $formWebinarButton.on("click", function (event) {
        event.preventDefault();
        var $buttonForm = $(this);
        let $activeCookies = true,
            $form = $buttonForm.closest('form');

        if (typeof OnetrustActiveGroups != 'undefined' && (!OnetrustActiveGroups.includes("C0003") || !OnetrustActiveGroups.includes("C0004"))) { // Functional and targeting and  Cookies
            $form.find('.cookies-message--advice').fadeOut(function () {
                $form.find('.cookies-message--error').fadeIn();
            })
            $activeCookies = false;
        } else {
            $form.find('.cookies-message--error').fadeOut();
        }

        if (validateForm($formWebinar) && $activeCookies) {
            $formWebinar.addClass("disabled");
            $formWebinarButton.attr('disabled', 'disabled');
            $formWebinarButton.addClass("button--loading");
            // Function to set form process

            const dialCode = document.querySelector('.iti__selected-dial-code').innerHTML;
            var $name = $formWebinar.find('input[name=name]'),
                $lastname = $formWebinar.find('input[name=lastname]'),
                $email = $formWebinar.find('input[type=email]'),
                $country = $formWebinar.find('input[name=country]'),
                $listID = $formWebinar.attr('data-list'),
                $title = $formWebinar.find('input[name=title]'),
                $id_webinar = $formWebinar.find('input[name=id_webinar]').val(),
                $gtw_webinar_id = $formWebinar.find('input[name=gtw_webinar_id]').val(),
                $array_country = $formWebinar.find('input[name=array_country]').val(),
                $aceptoPoliticas = $formWebinar.find('input[name=acepto_politicas]').is(':checked'),
                $aceptoPromociones = $formWebinar.find('input[name=acepto_promociones]').is(':checked'),
                $industry = $formWebinar.find('select[name=industry]').val(),
                $phone = $formWebinar.find('input[name=phone]').val();
            if ($phone) {
                $phone = dialCode + $phone;
            }
            var data = {
                name: $name.val(),
                lastname: $lastname.val(),
                email: $email.val(),
                country_code: $country.attr('data-code'),
                country: $country.val(),
                listID: $listID,
                id_webinar: $id_webinar,
                gtw_webinar_id: $gtw_webinar_id,
                array_country: $array_country,
                title: $title.val(),
                acepto_politicas: $aceptoPoliticas,
                acepto_promociones: $aceptoPromociones,
                industry: $industry,
                phone: $phone
            };

            sentDataBackend(data, "subscriber-webinar", "webinar", $formWebinar, $buttonForm);

            allowCookies('email_subscriber', $email.val(), 100000, 'C0003');
            allowCookies('acepto_promociones', $aceptoPromociones, 100000, 'C0003');
            setCookie('acepto_politicas', $aceptoPoliticas, 100000);

            displayWebinarResourcesSection();
        }// Function to get data the form
    });
*/
    function handleFormSubmission($form, $formButton, formType) {
        $formButton.on("click", function (event) {
            event.preventDefault();
            var $buttonForm = $(this);
            let $activeCookies = true;

            if (typeof OnetrustActiveGroups != 'undefined' && (!OnetrustActiveGroups.includes("C0003") || !OnetrustActiveGroups.includes("C0004"))) {
                $form.find('.cookies-message--advice').fadeOut(function () {
                    $form.find('.cookies-message--error').fadeIn();
                })
                $activeCookies = false;
            } else {
                $form.find('.cookies-message--error').fadeOut();
            }

            if (validateForm($form) && $activeCookies) {
                $form.addClass("disabled");
                $formButton.attr('disabled', 'disabled');
                $formButton.addClass("button--loading");

                const dialCode = document.querySelector('.iti__selected-dial-code').innerHTML;
                const $name = $form.find('input[name=name]'),
                    $lastname = $form.find('input[name=lastname]'),
                    $email = $form.find('input[type=email]'),
                    $country = $form.find('input[name=country]'),
                    $listID = $form.attr('data-list'),
                    $title = $form.find('input[name=title]'),
                    $id_webinar = $form.find('input[name=id_webinar]').val(),
                    $gtw_webinar_id = (formType === 'webinar') ? $form.find('input[name=gtw_webinar_id]').val() : null,
                    $array_country = $form.find('input[name=array_country]').val(),
                    $aceptoPoliticas = $form.find('input[name=acepto_politicas]').is(':checked'),
                    $aceptoPromociones = $form.find('input[name=acepto_promociones]').is(':checked'),
                    $industry = $form.find('select[name=industry]').val();
                let $phone = $form.find('input[name=phone]').val();
                if ($phone) {
                    $phone = dialCode + $phone;
                }
                const data = {
                    name: $name.val(),
                    lastname: $lastname.val(),
                    email: $email.val(),
                    country_code: $country.attr('data-code'),
                    country: $country.val(),
                    listID: $listID,
                    id_webinar: $id_webinar,
                    gtw_webinar_id: $gtw_webinar_id,
                    array_country: $array_country,
                    title: $title.val(),
                    acepto_politicas: $aceptoPoliticas,
                    acepto_promociones: $aceptoPromociones,
                    industry: $industry,
                    phone: $phone
                };


                sentDataBackend(data, "subscriber-" + formType, formType, $form, $buttonForm);

                allowCookies('email_subscriber', $email.val(), 100000, 'C0003');
                allowCookies('acepto_promociones', $aceptoPromociones, 100000, 'C0003');
                setCookie('acepto_politicas', $aceptoPoliticas, 100000);
                if (formType === "webinar") {
                    displayWebinarResourcesSection();
                }
            }
        });
    }
    // Llamada para manejar el formulario de webinar
    handleFormSubmission($("#form-webinar"), $("#form-webinar button"), "webinar");

    // Llamada para manejar el formulario de podcast
    handleFormSubmission($("#form-podcast"), $("#form-podcast button"), "podcast");


    function setCookieWebinar($id_webinar, $joinUrl) {
        var cookieSubscriptionArray = [], cookieSubscriptionString, $webinar_subscription_item;

        if (!!readCookie('webinar_subscription_v2')) {
            cookieSubscriptionArray = JSON.parse(readCookie('webinar_subscription_v2'));
        }

        $webinar_subscription_item = { idWebinar: $id_webinar, joinUrl: $joinUrl };
        cookieSubscriptionArray.push($webinar_subscription_item);

        allowCookies('webinar_subscription_v2', JSON.stringify(cookieSubscriptionArray), 100000, 'C0003');

        $(".webinar-internal .subscribe-next-webinar .join-webinar a").attr('href', $joinUrl);
    }

    function validateField(field) {
        var emailRegex = new RegExp(
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
        ),
            urlRegex = new RegExp(
                /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi
            ),
            numberRegex = new RegExp("^[0-9]+$"),
            val = field.val(),
            $parent = field.closest(".field-item");

        if (!val && field.hasClass('required')) {
            $parent.addClass('error');
        } else if (field.hasClass("email") && !val.match(emailRegex)) {
            $parent.addClass("error");
            $parent.find('.dp-message p').html('¡Ouch! Ingresa un Email v&aacutelido.');
        } else if (
            field.hasClass("check") &&
            field.hasClass("required") &&
            !field.is(":checked")
        ) {
            $parent.addClass("error");
        }
    }// Function to validate fields

    function validateForm(form) {
        $("input, textarea, select", form).each(function () {
            validateField($(this));
        });

        return $(form).find(".error").length === 0 ? true : false;
    }// Function to validate form

    function clearForm(form) {
        $("input:not(.button,[type='checkbox']), textarea", form).val("");
        form.find("input:checkbox").removeAttr("checked");
    }// Clear fields the form

    $('form .required').blur(function () {
        var fieldItem = $(this).closest('.field-item');

        if ((fieldItem.hasClass('error')) && ($(this).val())) {
            fieldItem.removeClass('error');
        }
    });// Validate if complete field

    $('form .check.required').click(function () {
        var fieldItem = $(this).closest('.field-item');

        if ((fieldItem.hasClass('error')) && ($(this).is(':checked'))) {
            fieldItem.removeClass('error');
        }
    });// Validate if checked the checkbox

    function sentDataBackend(data, action, from_form, $form, $buttonForm) {
        const actionHandlers = {
            "subscriber-questions": handleSubscriberAction,
            "Academy-Sugerencias-Home": handleSubscriberAction,
            "Academy-Sugerencias-Curso": handleSubscriberAction,
            "Academy-Sugerencias-Webinar": handleSubscriberAction,
            "Academy-Sugerencias-Capsula": handleSubscriberAction,
            "subscriber-webinar": handleSubscriberWebinar,
            "subscriber-podcast": handleSubscriberPodcast,
        };

        jQuery.ajax({
            type: "POST",
            url: local_object.ajax_url,
            data: {
                data: data,
                from_form: from_form,
                action: "submits_backend"
            },
            success: function (response) {
                if (actionHandlers[action]) {
                    actionHandlers[action](response, $form, $buttonForm);
                }

                setTimeout(function () {
                    $(".form-message").removeClass('active');
                    $form.removeClass("success");
                }, 6000);
            }
        });
    }

    function handleSubscriberAction(response, $form, $buttonForm) {
        setTimeout(function () {
            $buttonHideForm.click();
        }, 6000);

        setTimeout(function () {
            $form[0].reset();
            $buttonForm.attr('disabled', false);
            $form.removeClass("disabled");
            $buttonForm.removeClass("button--loading");
            $form.addClass("success");
        }, 2000);
    }

    function handleSubscriberWebinar(response, $form, $buttonForm) {
        if (!$(".overlay-subscribe").hasClass("subscribe-next-webinar")) {
            setTimeout(function () {
                $(".webinar-internal .overlay-subscribe.webinar").fadeOut(1000, function () {
                    $(".webinar-internal .video-iframe").removeClass("overlay");
                });
            }, 3000);
        }

        var joinUrl_result = '',
            webinar_type = $('.main-content--webinar').attr('data-type');

        try {
            var obj = JSON.parse(response);
            joinUrl_result = obj.joinUrl;
        } catch (err) {
            console.log('response: ' + response + '. Javascript error: ' + err.message);
        }

        if ((webinar_type == '4' || webinar_type == '0') && (joinUrl_result == '')) {
            console.log('Se ha producido un error. Tipo de webinar: ' + webinar_type + '. response.joinUrl vuelve vacío.')
            $(".form-message").addClass('active');
            $form[0].reset();
            $buttonForm.attr('disabled', false);
            $form.removeClass("disabled");
            $buttonForm.removeClass("button--loading");
        } else {
            setCookieWebinar(data.id_webinar, joinUrl_result);
            if ($(".overlay-subscribe").hasClass("subscribe-next-webinar")) {
                $(".webinar-internal .overlay-subscribe.webinar").hide();
                $(".webinar-internal .subscribe-next-webinar").fadeIn(500);
                $(".webinar-internal .subscribe-next-webinar").css('display', 'flex');
            }
        }
    }

    function handleSubscriberPodcast(response, $form, $buttonForm) {
        $('.video-iframe').removeClass('suggestion-overlay');
        $('.video-iframe').removeClass('overlay');
        setCookie("webinar_podcast_v2", 'true', 100000);
    }




    $(".c-tabs__tab-indicator").each(function (index) {

        $(".c-tabs__tab-indicator").removeClass("active");

        if (location.hash == ('#' + $(this).attr("data-href"))) {

            $(this)
                .parent()
                .attr("data-active-tab", index + 1);

            if ($(this).attr("data-href") == 'todos') {
                $(".flip-card").css("display", "flex");
            }
            if ($(this).attr("data-href") == 'nuevos') {
                $(".flip-card.ribbon--new").css("display", "flex");
                $(".flip-card.ribbon--next").css("display", "none");
                $(".c-tabs__tab").css("display", "block")
            }
            if ($(this).attr("data-href") == 'proximos') {
                $(".flip-card.ribbon--new").css("display", "none");
                $(".flip-card.ribbon--next").css("display", "flex");
                $(".c-tabs__tab").css("display", "block")
            }

            $(".c-tabs__tab-indicator").removeClass("active");
            $(this).addClass("active");
        }

        $(this).on("click", function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                return false;
            }

            var scrollHeight = 50;
            if ($('.post-type-archive-lp_course').length == 0) {
                ScrollReveal().reveal(".flip-card", slideUp);
            } else {
                ScrollReveal().destroy();
            }
            var dataHref = $(this).attr("data-href");

            $(this)
                .parent()
                .attr("data-href", dataHref);
            location.hash = '';
            location.hash = dataHref;

            if ($('header').find('.hello-bar').length > 0) {
                scrollHeight = 100;
            }
            $("html, body").animate({
                scrollTop: $(".section--tabs").offset().top - scrollHeight
            },
                1000
            );
            $(this)
                .parent()
                .attr("data-active-tab", index + 1);
            if ($('.post-type-archive-lp_course').length > 0) {
                switch (dataHref) {
                    case 'todos':
                        $(".flip-card").css("display", "flex");
                        ScrollReveal().reveal(".flip-card", slideUp);
                        break;
                    case 'nuevos':
                        $(".flip-card").css("display", "none");
                        $(".flip-card.ribbon--new").css("display", "flex");
                        ScrollReveal().reveal(".flip-card.ribbon--new", slideUp);
                        break;
                    case 'proximos':
                        $(".flip-card").css("display", "none");
                        $(".flip-card.ribbon--next").css("display", "flex");
                        ScrollReveal().reveal(".flip-card.ribbon--next", slideUp);
                        break;
                }
                $(".c-tabs__tab").css("display", "block");
            }
            $(".c-tabs__tab-indicator").removeClass("active");
            $(this).addClass("active");
        });
    });// End Tabs functionality Automation

    $titleToggle.on('click', function () {
        var position = $(this).offset().top - 300;

        if ($(this).hasClass('minimize-toggle open')) {
            $(this).removeClass("open");
        } else {
            $titleToggle.removeClass("open");
            $(this).addClass("open");
            $scrollContainerMinCards.animate({
                scrollTop: position
            }, 1000);
        }
    });

    $('.more-info').on('click', function () {
        var parent = $(this).parents('figure:first');

        parent.toggleClass('expanded');
        if (parent.hasClass('expanded')) {
            $(this).html('<i class="academy-icon icon-less"></i>Ver menos info');
        } else {
            $(this).html('<i class="academy-icon icon-plus"></i>Ver más info');
        }
    });//Expand cards when click in view more

    function toggleMute() {
        if ($videoCourse.muted == true && $buttonMute.hasClass("audio-mute")) {
            $videoCourse.muted = false;
            $buttonMute.removeClass("audio-mute");
            $buttonMute.addClass("audio");
        } else if ($videoCourse.muted == true && $buttonMute.hasClass("audio-mute-white")) {
            $videoCourse.muted = false;
            $buttonMute.removeClass("audio-mute-white");
            $buttonMute.addClass("audio-white");
        } else if ($videoCourse.muted == false && $buttonMute.hasClass("audio")) {
            $videoCourse.muted = true;
            $buttonMute.removeClass("audio");
            $buttonMute.addClass("audio-mute");
        } else if ($videoCourse.muted == false && $buttonMute.hasClass("audio-white")) {
            $videoCourse.muted = true;
            $buttonMute.removeClass("audio-white");
            $buttonMute.addClass("audio-mute-white");
        }
    }// Function to toggle Mute video in desktop

    $buttonMute.on("click", toggleMute);
    // Function to mute or active audio in video course page

    function toggleMuteMobile() {
        if ($videoCourseMobile.muted == true && $buttonMuteMobile.hasClass("audio-mute")) {
            $videoCourseMobile.muted = false;
            $buttonMuteMobile.removeClass("audio-mute");
            $buttonMuteMobile.addClass("audio");
        } else if ($videoCourseMobile.muted == false && $buttonMuteMobile.hasClass("audio")) {
            $videoCourseMobile.muted = true;
            $buttonMuteMobile.removeClass("audio");
            $buttonMuteMobile.addClass("audio-mute");
        }
    }// Function to toggle Mute video in mobile

    $buttonMuteMobile.on("click", toggleMuteMobile);
    // Function to mute or active audio in video course page in mobile


    /*Function to set default values for data-values in each view*/
    $(".evaluation-form").on('click', function () {
        var $formModal = $(this);
        setTimeout(function () {
            $('.ready #popup_cancel').val($formModal.attr('data-cancel-value'));
            $('.ready #popup_ok').val($formModal.attr('data-ok-value'));
            $('.ready #popup_message').html($formModal.attr('data-title'));
        }, 100);
    });

    function progressBarChanged(element) {
        var progress = $(element).find(".progress"),
            anchor = $(element).attr("data-value");

        progress.css("width", anchor + "%");
    }//Progress Bar functions

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type == "attributes") {
                progressBarChanged($(mutation.target));
            }
        });
    });

    var targetNodes = $(".progress-bar"),
        config = {
            attributes: true
        };

    targetNodes.each(function () {
        progressBarChanged(this);
        observer.observe(this, config);
    });

    /*Init slider for webinar cards.*/
    $(".customer-logos").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false
    });

    $(".resources").slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        autoplaySpeed: 1500,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    infinite: false,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: true,
                    centerPadding: '15px',
                    mobileFirst: true,
                    infinite: false,
                }
            }
        ]
    });

    var webinarResourcesSettings = {
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        autoplaySpeed: 1500,
        arrows: true,
        dots: true,
        pauseOnHover: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: false
                }
            },
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true
                }
            }
        ]
    };

    $(".resources-extend").slick(webinarResourcesSettings);

    function displayWebinarResourcesSection() {
        //Display resources if exsits.
        if ($("article.complementary-resources").length == 0) return;
        $(".resources-extend").slick('unslick');
        $('article.complementary-resources').removeClass('hidden');
        $(".resources-extend").slick(webinarResourcesSettings);
    }

    var slideUp = {
        distance: "30px",
        origin: "bottom",
        opacity: null,
        delay: 300,
        duration: 600,
        easing: "ease-in-out",
        scale: 0.9,
        opacity: 0.5,
        viewFactor: 0.5
    };

    if ($(".section--tabs").length > 0) {
        ScrollReveal().reveal(".flip-card", slideUp);
    }//Init cards animation on scroll - using ScrollReveal

    if ($(".past-webinars").length > 0) {
        ScrollReveal().reveal(".past-webinars .webinar", slideUp);
    }//Init cards animation on scroll - using ScrollReveal - Past Webinars

    $accordionTab.on("click", function () {
        $(this).toggleClass("active");
    });// Accordion tab

    function geolocationCountry() {
        fetch('https://extreme-ip-lookup.com/json/').then(function (res) {
            return res.json();
        }).then(function (response) {
            $("#country-input").attr("data-code", response.countryCode);
            var found = getCountryByCode(response.countryCode);
            $("#country-input").val(found[0].name);
        }).catch(function (data, status) {
            console.log('Request failed');
        });
    }// Function to geolocation country

    geolocationCountry(); //Call function previus

    function getCountryByCode(code) {
        var data = $.getJSON({ 'url': $baseUrl + "/wp-content/themes/doppler-webpack/js/json/json_es.json", 'async': false });
        data = JSON.parse(data.responseText);

        return data.filter(
            function (data) {
                return data.code == code
            }
        );
    }

    var options = {
        //url: "https://restcountries.eu/rest/v2/all",
        url: $baseUrl + "/wp-content/themes/doppler-webpack/js/json/json_es.json",

        getValue: "name",

        template: {
            type: "custom",
            method: function (value, item) {
                return "<img  src='" + item.flag + "' />" + value;
            }
        },

        list: {
            match: {
                enabled: true
            },
            onChooseEvent: function () {
                var selectedItemValue = $("#country-input").getSelectedItemData().name,
                    selectedCode = $("#country-input").getSelectedItemData().code;

                if (selectedItemValue != undefined) {
                    $("#country-input").attr("data-name", selectedItemValue);
                    $("#country-input").attr("data-code", selectedCode);
                } else {
                    $("#country-input").attr("data-name", "");
                }
            },

            onKeyEnterEvent: function () {
                var selectedItemValue = $("#country-input").getSelectedItemData().name,
                    selectedCode = $("#country-input").getSelectedItemData().code;

                if (selectedItemValue != undefined) {
                    $("#country-input").attr("data-name", selectedItemValue);
                    $("#country-input").attr("data-code", selectedCode);
                } else {
                    $("#country-input").attr("data-name", "");
                }
            },

            onSelectItemEvent: function () {
                var selectedItemValue = $("#country-input").getSelectedItemData().name,
                    selectedCode = $("#country-input").getSelectedItemData().code;

                if (selectedItemValue != undefined) {
                    $("#country-input").attr("data-name", selectedItemValue);
                    $("#country-input").attr("data-code", selectedCode);
                } else {
                    $("#country-input").attr("data-name", "");
                }
            },

            onHideListEvent: function () {
                var selectedItemValue = $("#country-input").getSelectedItemData().name;

                if (selectedItemValue != undefined) {
                    $("#country-input").attr("data-name", selectedItemValue);
                } else {
                    $("#country-input").attr("data-name", "");
                }
            }

        },

        theme: "square",
        highlightPhrase: false
    };// Function for country select

    $("#country-input").easyAutocomplete(options);

    $("#country-input").blur(function () {
        if ($("#country-input").attr("data-name") == "")
            $(this).val("");
    });// Function for country select for name

    $("#go-to-formats").click(function () {
        var offset = -200; //Offset of 20px

        $('html, body').animate({
            scrollTop: $("#section-formates").offset().top + offset
        }, 1000);
    });

    $('.share').on('click', function (e) {
        $(".float-circle").removeClass("no-animation");
        $(".float-circle").toggleClass("open");
    });

    $toggleUserMenu.on("click", function () {
        $(".session-menu").toggleClass("active");
        return false;
    });// Open click menu user options

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }// Function to set cookie


    function getURLParam(prop) {
        var params = {},
            search = location.search.split('?')[1],
            definitions = !!search ? search.split('&') : [];

        definitions.forEach(function (val, key) {
            var parts = val.split('=', 2);
            params[parts[0]] = parts[1];
        });

        return (prop && prop in params) ? params[prop] : '';
    }// Function to read URL parameters

    function set_date_in_timezone(date, timezone, cod_country) {
        var date_in_timezone = moment.tz(date, timezone).format('D') + '/' + moment.tz(date, timezone).format('MMM').toUpperCase();
        date_in_timezone = date_in_timezone.slice(0, -1);
        var fecha_email = moment.tz(date, timezone).format('D') + '/' + moment.tz(date, timezone).format('MMM').toUpperCase();
        fecha_email = date_in_timezone.slice(0, -1);
        var time_in_timezone = moment.tz(date, timezone).format('hh:mm a').replace('.', '');
        var offset = moment.tz(date, timezone).format('Z');
        if (offset.charAt(1) == 0) {
            offset = offset.slice(0, 1) + offset.slice(2);
        }
        offset = "(GMT" + offset + ")";
        return { 'date_in_timezone': date_in_timezone, 'time_in_timezone': time_in_timezone, 'offset': offset, 'cod_country': cod_country, 'timezone': timezone, }
    }

    function set_time_webinar_in_card() {
        var figures = $('article').find('figure').filter('.webinar');
        if (figures.length != 0) {
            moment.locale('es');
            $.each(figures, function (key, value) {
                var string_date = $(this).attr('data-attr-date');
                var date_arg = moment.tz(string_date, "America/Buenos_Aires").format();
                var timezone_detected = set_date_in_timezone(date_arg, Intl.DateTimeFormat().resolvedOptions().timeZone, "");
                $(this).find('ul li span.date').html(timezone_detected.date_in_timezone);
                $(this).find('ul li span.time').html(timezone_detected.time_in_timezone);
                $(this).find('ul li span.gmt').html(timezone_detected.offset);

            });
        }
    }

    function set_time_webinar_interna() {
        var webinar = $('article.main-content--webinar').attr('data-attr-date');
        moment.locale('es'); // change the global locale to Spanish
        var date_arg = moment.tz(webinar, "America/Buenos_Aires").format();
        var timezone_detected = set_date_in_timezone(date_arg, Intl.DateTimeFormat().resolvedOptions().timeZone, "");
        var date_in_timezone = moment.tz(date_arg, Intl.DateTimeFormat().resolvedOptions().timeZone).format('D') + ' de ' + moment.tz(date_arg, Intl.DateTimeFormat().resolvedOptions().timeZone).format('MMMM');
        $('.list-tags .date').html(date_in_timezone);
        $('.list-tags .time').html(timezone_detected.time_in_timezone);
        $('.list-tags .gtm').html(timezone_detected.offset);
        var array_email = [];
        array_email.push(date_in_timezone);
        var aux;
        if (timezone_detected.time_in_timezone.substr(-2) == "am")
            aux = timezone_detected.time_in_timezone.replace("am", "a.m.");
        else
            aux = timezone_detected.time_in_timezone.replace("pm", "p.m.");
        array_email.push(aux);
        array_email.push(timezone_detected.offset);
        $('input[name="array_country"]').val(JSON.stringify(array_email));
    }

    function set_time_by_webinar() {
        if ($('input#is_page_webinar').length > 0) {
            set_time_webinar_in_card();
        }
        else {
            if ($('input#is_single_webinar').length > 0) {
                set_time_webinar_interna();
            }
        }
    }

    $accordionLessonHeader.on("click", function () {
        var $lessonItem = $(this).parent();
        if ($lessonItem.find(".lesson-title").hasClass("active-lesson")) {
            $lessonItem.find(".curriculum-lesson-classes").slideUp();
        } else {
            $lessonItem.find(".curriculum-lesson-classes").slideDown();
        }
        $lessonItem.find(".lesson-title").toggleClass("active-lesson");

    });// Accordion in lesson

    $tabCourse.on("click", function () {
        $tabLesson.removeClass("active");
        $tabLesson.addClass("inactive");
        $tabCourse.addClass("active");
        $('aside.curriculum').hide();
        $('article.main-content').show();
        $('article.complementary-resources').show();
        $('footer').show();
    });

    $tabLesson.on("click", function () {
        $tabCourse.removeClass("active");
        $tabCourse.addClass("inactive");
        $tabLesson.addClass("active");
        $('article.main-content').hide();
        $('article.complementary-resources').hide();
        $('aside.curriculum').show();
        $('footer').hide();
    });

    $tabPodcast.on("click", function () {
        $tabMorePodcasts.removeClass("active").addClass("inactive");
        $tabPodcast.addClass("active");
        $('aside.see-more').hide();
        $('article.main-content').show();
    });

    $tabMorePodcasts.on("click", function () {
        $tabPodcast.removeClass("active").addClass("inactive");
        $tabMorePodcasts.addClass("active");
        $('article.main-content').hide();
        $('aside.see-more').show();
    });

    function forceDownload(name, course, date) {
        var xhr = new XMLHttpRequest(),
            encodeName = encodeURI(name),
            encodeCourse = encodeURI(course),
            encodeDate = encodeURI(date),
            domainUrl = (local_object.is_prod == '1') ? 'certificate.php' : 'certificateqa.php',
            url = 'https://textify.fromdoppler.com/' + domainUrl + '?name=' + encodeName + '&course=Aprob%F3%20y%20finaliz%F3%20el%20curso%20+' + encodeCourse + '&date=dictado%20por%20especialistas%20de%20nuestra%20Academia%20el%20d%EDa%20' + encodeDate,
            fileName = 'certificacion-doppler.png';

        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }

    if ($('.video-iframe.overlay').hasClass('finish-evaluation')) {
        $('.main-content').addClass('has-overlay-finish-evaluation');
    }// If open overlay the finish evaluation add class

    if ($('.single-lp_course').length > 0) {
        $('html').css('overflow', 'auto');
    }//Force learnpress not to remove scrollbar on single course.

    if ($(window).width() <= 480) {
        $videoHero.remove();
        $('.section-hero--video-bg .overlay').addClass('videobg');
    } else if ($(window).width() <= 1366) {
        $videoHero.attr('src', '/wp-content/themes/doppler-webpack/img/video-hero-laptop.mp4');
    }// Remplace video hero

    if (window.location.hash) {
        var hashUrl = window.location.hash,
            top = $(hashUrl).offset().top - 80;

        $('html, body').animate({
            scrollTop: top
        }, 1500);
    }

    $cancelQuizLink.on("click", function (e) {
        e.preventDefault();
        var link = $(this);
        link.css('pointer-events', 'none');
        var user_id = link.attr('data-user');
        var item_id = link.attr('data-item');
        $.post(local_object.ajax_url, {
            action: "reset_user_quiz",
            user_id: user_id,
            item_id: item_id
        }).success(function (response) {
            if (response == '0') {
                console.log('Cancel quiz failed');
                return;
            }
            console.log(response);
            window.location.href = response;
        });
    });

    function nextButtonEnabled() {
        var $btn_next = $('.nav-lesson .next-lesson');

        if ($('.answer-options .option-check:checked').length > 0) {
            $btn_next.removeClass('lesson-disabled');
        }
        else {
            $btn_next.addClass('lesson-disabled');
        }
    }

    $('.answer-option').on('click', function () {
        setTimeout(function () {
            nextButtonEnabled();
        }, 100);
    });

    if ($('.form-questions').length > 0) {
        nextButtonEnabled();
    }

    if ($(".overlay-parcial")[0]) {
        $('body').addClass('fixed-scroll');
    }// Check if active class overlay-parcial to complete the exam and fixed scroll bar "Y"

    $(".link-suggestion, .link-suggestion-form").on("click", function (e) {
        e.preventDefault();
        var $field = $(".form-suggestion .field-item");
        if ($field.hasClass("error")) {
            $($field).removeClass("error");
        }
        $(".block-active")
            .fadeOut("fast")
            .removeClass("block-active")
            .siblings()
            .delay(250)
            .fadeIn("fast")
            .addClass("block-active");
    });

    otListener();
    // end of Document.Ready
});


(function ($) {
    $(window).on('load', function () {

        if (!!document.location.hash) {
            var hash = document.location.hash,
                $hashHref = $('a[href="' + hash + '"]');

            if ($hashHref.length > 0) {
                var height = $hashHref.offset().top;
                $('html, body').animate({
                    scrollTop: height - 250
                }, 1000);
                if ($hashHref.hasClass('c-tabs__tab-indicator')) {
                    $hashHref.click();
                }
            }
        }

        if (getUrlParameter('dplrid')) {
            var $emailHexa = getUrlParameter('dplrid'),
                $email = fromHex($emailHexa);
            document.cookie = 'cross-site-cookie=dplrid; SameSite=None; Secure';

            $("input[type='email']").val($email);
        } else {
            console.log('No parameter email');
        }

        // Function to decode email
        function fromHex(h) {
            var s = ''
            for (var i = 0; i < h.length; i += 2) {
                s += String.fromCharCode(parseInt(h.substr(i, 2), 16))
            }
            return decodeURIComponent(escape(s))
        }

        // Function params url
        function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };

    });

})(jQuery);


// Effect webinars and capsulas cards

(function () {
    var elements;
    var windowHeight;

    function init() {
        elements = document.querySelectorAll('.flip-card');
        windowHeight = window.innerHeight;
    }

    function checkPosition() {
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            var positionFromTop = elements[i].getBoundingClientRect().top;

            if (positionFromTop - windowHeight <= 0) {
                element.classList.add('fade-in-card');
                //element.classList.remove('hidden');
            }
            else {
                false;
            }
        }
    }

    window.addEventListener('scroll', checkPosition);
    window.addEventListener('resize', init);

    init();
    checkPosition();
})();
